module.exports = __webpack_public_path__ + "img/nft.0773d7ab.png";